<template>
    <div class="main main--hasHeader main--hasFooter">
        <div class="reserve04">
            <reserve-header :target_type="'drive'" :reserve_target="'check'"></reserve-header>
            <div class="fullContainer">
                <drive-reserved-list></drive-reserved-list>
            </div>
        </div>
    </div>
</template>
<script>
import reserveHeader from '../../organisms/BsReserveHeader.vue';
import driveReservedList from '../Drive/ListReservedView.vue'

export default {
    name: 'ReservedDriveView',
    data: function () {
        return {
        }
    },
    props: {
    },
    components: {
        driveReservedList,
        reserveHeader,
    },
    methods: {

    },
    computed: {

    }
}
</script>
